import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import CartIcon from '../cart/CartIcon';
import { getBrandUrl, getBrandName, getBrandCode } from '../brand/brandSelectors';
import { getShowCartPaths } from '../routing/flowSelectors';
import { setCartStatusReady } from '../cart/cartModule';

import HeaderImageLink from './HeaderImageLink';
import headerMessages from './headerMessages';



export const Header = ({
    brandUrl,
    brandName,
    brandCode,
    showCartPaths,
    goToCart
}) => {
    const heading = {
        ...headerMessages.pageHeader,
        values: { brandName }
    };

    return (
        <header className="header">
            {}
            <h1 className="header__h1">
                <FormattedMessage {...heading} />
            </h1>
            <div className="header-container">
                <HeaderImageLink brandUrl={brandUrl} brandName={brandName} brandCode={brandCode} />
                <Route
                    path={showCartPaths}
                    render={() => (
                        <CartIcon clickHandler={goToCart} />
                    )}
                />
            </div>
        </header>
    );
};

Header.propTypes = {
    
    brandUrl: PropTypes.string.isRequired,
    brandName: PropTypes.string.isRequired,
    brandCode: PropTypes.string.isRequired,
    showCartPaths: PropTypes.array.isRequired,
    
    goToCart: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    brandUrl: getBrandUrl(state),
    brandName: getBrandName(state),
    brandCode: getBrandCode(state),
    showCartPaths: getShowCartPaths(state)
});

const mapDispatchToProps = ({
    goToCart: setCartStatusReady
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
